import { render, staticRenderFns } from "./editBigExpressAddress.vue?vue&type=template&id=224a4b1e&scoped=true"
import script from "./editBigExpressAddress.vue?vue&type=script&lang=js"
export * from "./editBigExpressAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a4b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224a4b1e')) {
      api.createRecord('224a4b1e', component.options)
    } else {
      api.reload('224a4b1e', component.options)
    }
    module.hot.accept("./editBigExpressAddress.vue?vue&type=template&id=224a4b1e&scoped=true", function () {
      api.rerender('224a4b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/editBigExpressAddress.vue"
export default component.exports